import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

export default function ArbitrationHeader({
  name,
  avatar,
  arbitrationCollege,
  className,
}) {
  const { t } = useTranslation();
  return (
    <S.Container className={className}>
      <S.Avatar src={avatar} />
      <S.ContainerInfo>
        <S.DataList>
          <S.DataListItem>
            <S.DataListItemLabel>
              {t('arbitrationCollege')}:
            </S.DataListItemLabel>
            <S.DataListItemText>{arbitrationCollege}</S.DataListItemText>
          </S.DataListItem>
        </S.DataList>
        <S.Name>{name}</S.Name>
      </S.ContainerInfo>
    </S.Container>
  );
}

ArbitrationHeader.propTypes = {
  className: PropTypes.string,
  avatar: PropTypes.string,
  arbitrationCollege: PropTypes.string,
  name: PropTypes.string,
};

ArbitrationHeader.defaultProps = {
  className: null,
  avatar: null,
  arbitrationCollege: null,
  name: null,
};
